export const OPERATIONAL_EVENT_QUERY_KEY = `operational_events`
export const OPERATIONAL_EVENT_CONFIG_QUERY_KEY = `operational_event_config`
